import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchLiveReportById } from '../../predict/src/core/api/reporting/report-builder';
import { queryClient } from '../core/queryClient';

type FetchLiveReportByIdResult = Awaited<ReturnType<typeof fetchLiveReportById>>;
type LiveReportByIdQueryOptions = Omit<
  QueryObserverOptions<FetchLiveReportByIdResult>,
  'queryKey' | 'queryFn'
>;

export const liveReportByIdQueryKey = (organisationId: string, workspaceId: string, reportId: string) => [
  'liveReportById',
  organisationId,
  workspaceId,
  reportId
];

export const liveReportByIdQuery = (
  workspaceId: string,
  organisationId: string,
  reportId: string,
  isConsolidation: boolean,
  options?: LiveReportByIdQueryOptions
): QueryObserver<FetchLiveReportByIdResult> =>
  new QueryObserver<FetchLiveReportByIdResult>(queryClient, {
    queryKey: liveReportByIdQueryKey(organisationId, workspaceId, reportId),
    queryFn: () => fetchLiveReportById(workspaceId, organisationId, reportId, isConsolidation),
    ...options
  });
